import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useNavigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AppStateProvider } from "@/context/AppState";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Landing } from "@/components/Landing";
import { DashboardLayout } from "@/components/DashboardLayout";
import Dashboard from "@/pages/Dashboard";
import Calendario from "@/pages/Calendario";
import AgendaView from "@/pages/AgendaView";
import Clientes from "@/pages/Clientes";
import Terapeutas from "@/pages/Terapeutas";
import Disponibilidad from "@/pages/Disponibilidad";
import Efemerides from "@/pages/Efemerides";
import Afiliados from "@/pages/Afiliados";
import AffiliatePortal from "@/pages/AffiliatePortal";
import ConfirmPage from "@/pages/ConfirmPage";
import AuthCallback from "@/pages/AuthCallback";
import { Login, Register, ForgotPassword, ResetPassword } from "@/pages/AuthPages";

const LandingRoute = () => {
  const navigate = useNavigate();
  return <Landing onStart={() => navigate("/login")} />;
};

const AppRoutes = () => {
  const location = useLocation();
  if (location.hash && location.hash.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<LandingRoute />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/confirmar/:id" element={<ConfirmPage />} />
      <Route path="/afiliado/:code" element={<AffiliatePortal />} />
      <Route
        path="/app"
        element={
          <ProtectedRoute>
            <AppStateProvider>
              <DashboardLayout />
            </AppStateProvider>
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/app/calendario" replace />} />
        <Route path="panel" element={<Dashboard />} />
        <Route path="calendario" element={<Calendario />} />
        <Route path="agenda" element={<AgendaView />} />
        <Route path="clientes" element={<Clientes />} />
        <Route path="terapeutas" element={<Terapeutas />} />
        <Route path="disponibilidad" element={<Disponibilidad />} />
        <Route path="efemerides" element={<Efemerides />} />
        <Route path="afiliados" element={<Afiliados />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

function App() {
  useEffect(() => { document.title = "Agenda Terapias"; }, []);
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
          <Toaster position="top-center" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
